// export function expertBio() {
//     $('.expert-expand').click(function(e) {
//         e.preventDefault();
//         $(this).toggleClass('active');
//         var expertBio = $(this).closest('.expert').find('.expert-bio');
//         if(expertBio.is(':visible')) {
//             expertBio.slideUp('fast');
//         } else {
//             expertBio.slideDown('fast');
//         }
//     });
// }


export function expertBio() {
  $('.expert-expand').click(function(e) {
    e.preventDefault();
    const expertContainer = $(this).closest('.expert');
    const expertContent = expertContainer.find('.expert-content');
    const expertBio = expertContainer.find('.expert-bio');
    const expertName = expertContainer.find('.expert-name');

    // Toggle active class
    expertContainer.toggleClass('active');
    expertContent.toggleClass('active');
    expertBio.toggleClass('active');
    expertName.toggleClass('active');
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/expertBio.js